<template>
  <div>
    <div class="k-modal-title mb-2">Выберите состав меню</div>
    <div
      v-for="(type, index) in meal_types"
      :key="index" 
      class="k-modal-sticker mb-1" 
      :class="{ selected: isInSelected(type) }"
      @click="select(type)"
    >{{ type.title }}</div>
    <div class="k-modal-button mt-4 mb-2" :class="{ disabled: !currentData.length }" @click="$emit('next')">
      Далее
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    }
  },
  data: () => ({
    meal_types: [
      { type: 'breakfast', title: 'Завтрак' },
      { type: 'lunch', title: 'Обед' },
      // { type: 'brunch', title: 'Перекус' },
      { type: 'dinner', title: 'Ужин' },
    ],
    // selected_meal_types: [],
  }),
  computed: {
    currentData: {
      get() { return this.data },
      set(value) { this.$emit('update', value) }
    }
  },
  methods: {
    isInSelected({ type }) {
      return this.currentData.some(el => el === type)
    },
    select({ type }) {
      const exist = this.currentData.find(el => el === type)
      if (exist) {
        this.currentData = this.currentData.filter(el => el !== type)
      } else {
        this.currentData.push(type);
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>